<template>
  <div class="grid">
    <slot name="label" :label="label" :rightText="rightText">
      <span class="pb-1" style="font-weight: 500; min-height: 24.5px">
        {{ label }}
        <span v-if="rightText" class="right-text">{{ rightText }}</span>
      </span>
    </slot>
    <slot></slot>
    <span v-if="errorMessage" class="flex items-center" style="margin-top: 0px; color: #ff1100">
      <svg v-if="isErrorMessageMarker" class="mr-1" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8 1.5C4.2 1.5 1 4.7 1 8.5C1 12.3 4.2 15.5 8 15.5C11.8 15.5 15 12.4 15 8.5C15 4.6 11.9 1.5 8 1.5ZM7.5 4.5H8.5V9.5H7.5V4.5ZM8 12.7C7.6 12.7 7.2 12.3 7.2 11.9C7.2 11.5 7.5 11.1 8 11.1C8.4 11.1 8.8 11.5 8.8 11.9C8.8 12.3 8.4 12.7 8 12.7Z"
          fill="#FF1100"
        />
        <path
          opacity="0.01"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.5002 4.5H8.5002V9.5H7.5002V4.5ZM8.0002 12.7C7.6002 12.7 7.2002 12.3 7.2002 11.9C7.2002 11.5 7.5002 11.1 8.0002 11.1C8.4002 11.1 8.8002 11.5 8.8002 11.9C8.8002 12.3 8.4002 12.7 8.0002 12.7Z"
          fill="#DA1E28"
        />
      </svg>
      {{ errorMessage }}
    </span>
    <span v-else-if="!errorMessage && isSuccess && successMessage" class="flex items-center" style="margin-top: 4px; color: #28c76f">
      <svg v-if="isSuccessMessageMarker" class="mr-1" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#CAF9DF" />
        <path
          d="M13.6436 5.95214C13.5413 5.85511 13.4039 5.80078 13.2607 5.80078C13.1175 5.80078 12.98 5.85511 12.8778 5.95214L7.95419 10.824L5.98471 8.8117C5.93769 8.75101 5.87776 8.7008 5.80895 8.66448C5.74013 8.62817 5.66408 8.60658 5.5859 8.6012C5.50772 8.59582 5.42921 8.60676 5.35578 8.63329C5.28235 8.65982 5.21567 8.70133 5.16024 8.75498C5.10482 8.80863 5.06197 8.87317 5.03456 8.94425C5.00716 9.01533 4.99582 9.09126 5.00137 9.16694C5.00693 9.24262 5.02924 9.31627 5.06675 9.38288C5.10427 9.44949 5.15617 9.50753 5.21888 9.55305L7.6259 11.989C7.6259 12.0949 7.84478 12.2008 7.95419 12.2008C8.03912 12.2008 8.12285 12.1816 8.19881 12.1449C8.27477 12.1081 8.34085 12.0547 8.39181 11.989L13.6436 6.69352C13.7438 6.59453 13.8 6.46144 13.8 6.32283C13.8 6.18422 13.7438 6.05113 13.6436 5.95214Z"
          fill="#28C76F"
        />
      </svg>
      {{ successMessage }}
    </span>
  </div>
</template>

<script>
export default {
  name: "InputForm",
  props: {
    label: String,
    rightText: String,
    errorMessage: String,
    successMessage: String,
    isSuccess: {
      type: Boolean,
      default: false,
    },
    isErrorMessageMarker: {
      type: Boolean,
      default: true,
    },
    isSuccessMessageMarker: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
.right-text {
  font-weight: 400;
  font-size: 14px;
  color: #4839eb;
}
</style>
